module.exports = __webpack_public_path__ + "img/Clutch cover.69ad3190.jpg";